import React, { Component } from 'react';
import { toast } from 'react-toastify';

import { uploadFaqImage, validateImageFile, splitImageUrls, joinImageUrls } from '../uploadImage';

/**
 * Ô nhập ảnh hướng dẫn của một FAQ.
 *
 * Nhân viên CSKH chọn file từ máy, ảnh được tải lên storage rồi link tự điền vào. Ô dán link thủ
 * công vẫn giữ để dùng lại ảnh đã có sẵn trên hệ thống.
 *
 * Giá trị đi ra ngoài vẫn là chuỗi link ngăn nhau bằng dấu phẩy, đúng như dữ liệu đang lưu.
 */
export default class FaqImageField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadingCount: 0,
            showManualInput: false,
        };
        this.fileInputRef = React.createRef();
    }

    urls = () => splitImageUrls(this.props.value);

    emit = (urls) => {
        this.props.onChange(joinImageUrls(urls));
    };

    handlePickFiles = (event) => {
        const files = Array.from(event.target.files || []);

        // Cho chọn lại đúng file vừa chọn (trình duyệt không bắn onChange nếu giá trị không đổi).
        event.target.value = '';

        if (files.length === 0) {
            return;
        }

        const invalid = files.map(validateImageFile).find(Boolean);
        if (invalid) {
            toast.warning(invalid);
            return;
        }

        this.setState((prev) => ({ uploadingCount: prev.uploadingCount + files.length }));

        files.forEach((file) => {
            uploadFaqImage(file)
                .then((url) => {
                    // Đọc lại từ props chứ không gom sẵn mảng: nhiều ảnh tải xong lệch nhau,
                    // gom sẵn thì ảnh về sau ghi đè mất ảnh về trước.
                    const current = this.urls();
                    if (!current.includes(url)) {
                        this.emit([...current, url]);
                    }
                })
                .catch((error) => toast.error(error.message || `Không tải được "${file.name}".`))
                .then(() => this.setState((prev) => ({ uploadingCount: prev.uploadingCount - 1 })));
        });
    };

    handleRemove = (url) => {
        this.emit(this.urls().filter((item) => item !== url));
    };

    handleMove = (index, step) => {
        const urls = this.urls();
        const target = index + step;
        if (target < 0 || target >= urls.length) {
            return;
        }
        const next = [...urls];
        [next[index], next[target]] = [next[target], next[index]];
        this.emit(next);
    };

    renderThumbnails() {
        const urls = this.urls();
        if (urls.length === 0) {
            return null;
        }

        return (
            <div className="cs-thumbs">
                {urls.map((url, index) => (
                    <div className="cs-thumb" key={url}>
                        <a href={url} target="_blank" rel="noopener noreferrer" title={url}>
                            <img src={url} alt={`Ảnh ${index + 1}`} />
                        </a>

                        <button
                            type="button"
                            className="cs-thumb__remove"
                            title="Xoá ảnh này"
                            onClick={() => this.handleRemove(url)}
                        >
                            ×
                        </button>

                        <div className="cs-thumb__bar">
                            <button
                                type="button"
                                title="Chuyển lên trước"
                                disabled={index === 0}
                                onClick={() => this.handleMove(index, -1)}
                            >
                                ←
                            </button>
                            <span className="cs-thumb__index">{index + 1}</span>
                            <button
                                type="button"
                                title="Chuyển ra sau"
                                disabled={index === urls.length - 1}
                                onClick={() => this.handleMove(index, 1)}
                            >
                                →
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    render() {
        const { uploadingCount, showManualInput } = this.state;
        const urls = this.urls();

        return (
            <div className="cs-field">
                <label>Ảnh hướng dẫn</label>

                <div>
                    <input
                        ref={this.fileInputRef}
                        type="file"
                        accept="image/png,image/jpeg,image/gif,image/webp"
                        multiple
                        style={{ display: 'none' }}
                        onChange={this.handlePickFiles}
                    />

                    <button
                        type="button"
                        className="btn btn-outline-primary mr-2"
                        disabled={uploadingCount > 0}
                        onClick={() => this.fileInputRef.current.click()}
                    >
                        {uploadingCount > 0 ? `Đang tải lên ${uploadingCount} ảnh…` : <><i className="fa-solid fa-cloud-arrow-up mr-1" />Chọn ảnh từ máy</>}
                    </button>

                    <button
                        type="button"
                        className="btn btn-link px-0"
                        onClick={() => this.setState({ showManualInput: !showManualInput })}
                    >
                        {showManualInput ? 'Ẩn ô dán link' : 'Dán link có sẵn'}
                    </button>
                </div>

                {this.renderThumbnails()}

                {showManualInput && (
                    <input
                        type="text"
                        className="form-control mt-2"
                        placeholder="https://data4.ikara.co/....jpg,https://..."
                        value={this.props.value || ''}
                        onChange={(e) => this.props.onChange(e.target.value)}
                    />
                )}

                <small className="cs-hint">
                    {urls.length > 0
                        ? `${urls.length} ảnh. Chatbot gửi kèm theo đúng thứ tự này, sau phần chữ.`
                        : 'Chọn ảnh từ máy để tải lên, hoặc dán link ảnh đã có. Chatbot gửi kèm khi trả lời bằng FAQ này.'}
                </small>
            </div>
        );
    }
}
